const en = {
  // Common
  'common.loading': 'Loading...',
  'common.retry': 'Retry',
  'common.refresh': 'Refresh',
  'common.search': 'Search',
  'common.track': 'Track',
  'common.applyFilters': 'Apply Filters',
  'common.reset': 'Reset',
  'common.exportExcel': 'Export Excel',
  'common.print': 'Print',
  'common.printing': 'Printing...',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.saveChanges': 'Save Changes',
  'common.saving': 'Saving...',
  'common.edit': 'Edit',
  'common.view': 'View',
  'common.status': 'Status',
  'common.history': 'History',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.fromDate': 'From Date',
  'common.toDate': 'To Date',
  'common.keyword': 'Keyword',
  'common.allStatus': 'All Status',
  'common.allEmirates': 'All Emirates',
  'common.notAvailable': 'N/A',
  'common.actions': 'Actions',
  'common.pickupDate': 'Pickup Date',
  'common.deliveryDate': 'Delivery Date',
  'common.voucherNo': 'Voucher No',
  'common.clientBillNo': 'Client Bill No',
  'common.customer': 'Customer',
  'common.address': 'Address',
  'common.location': 'Location',
  'common.emirate': 'Emirate',
  'common.selectEmirate': 'Select Emirate',
  'common.noAddressesAvailable': 'No addresses available',
  'common.contactSupportAddresses': 'Please contact support to add addresses',
  'common.selectAddressFirst': 'Please select an address first',
  'common.loadMore': 'Load More',
  'common.loadingMore': 'Loading more...',
  'common.noMoreToLoad': 'No more records to load',
  'common.language': 'Language',
  'common.english': 'English',
  'common.arabic': 'Arabic',
  'common.collapse': 'Collapse menu',
  'common.expand': 'Expand menu',

  // App / logout
  'app.logout.title': 'Confirm Sign Out',
  'app.logout.subtitle': 'Are you sure you want to sign out?',
  'app.logout.warningTitle': 'You will be logged out of your account',
  'app.logout.warningBody': "All unsaved changes will be lost and you'll need to sign in again to access your account.",
  'app.logout.confirm': 'Yes, Sign Out',

  // Sidebar
  'sidebar.brandTitle': 'Delivery Portal',
  'sidebar.brandSubtitle': 'Client Dashboard',
  'sidebar.userFallback': 'User Name',
  'sidebar.dashboard': 'Dashboard',
  'sidebar.newOrder': 'New Order',
  'sidebar.uploadOrders': 'Upload Orders',
  'sidebar.deliveries': 'Deliveries',
  'sidebar.tracking': 'Tracking',
  'sidebar.trackOrders': 'Track Orders',
  'sidebar.trackByCustomer': 'Track by Customer',
  'sidebar.trackByBillNo': 'Track by Bill No',
  'sidebar.myCustomers': 'My Customers',
  'sidebar.batchPrinting': 'Batch Printing',
  'sidebar.reports': 'Reports',
  'sidebar.orderReports': 'Order Reports',
  'sidebar.customerReport': 'Customer Report',
  'sidebar.paymentReport': 'Payment Report',
  'sidebar.returnReport': 'Return Report',
  'sidebar.vatReport': 'VAT Report',
  'sidebar.profile': 'Profile',
  'sidebar.logout': 'Logout',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': "Welcome back! Here's what's happening with your deliveries.",
  'dashboard.errorTitle': 'Error Loading Dashboard',
  'dashboard.errorNetwork': 'Network Error - Failed to load dashboard data',
  'dashboard.totalCustomers': 'Total Customers',
  'dashboard.totalOrders': 'Total Orders',
  'dashboard.todaysOrders': "Today's Orders",
  'dashboard.todayDelivered': 'Today Delivered',
  'dashboard.totalClientMoney': 'Total Client Money',
  'dashboard.totalClientReturns': 'Total Client Returns',
  'dashboard.fromLastMonth': 'from last month',
  'dashboard.pickupDeliveryStatus': 'Pickup / Delivery Status',
  'dashboard.noData': 'No Data',
  'dashboard.processing': 'Processing',
  'dashboard.delivered': 'Delivered',
  'dashboard.returned': 'Returned',
  'dashboard.cancelled': 'Cancelled',
  'dashboard.deliveryStatistics': 'Delivery Statistics',
  'dashboard.todaysStatus': "Today's Status",
  'dashboard.todayProcessing': 'Today Processing',
  'dashboard.todayReturned': 'Today Returned',
  'dashboard.todayCancelled': 'Today Cancelled',
  'dashboard.recentDeliveries': 'Recent Deliveries',
  'dashboard.viewAll': 'View All',
  'dashboard.noRecent': 'No recent deliveries found',
  'dashboard.colVoucher': 'VOUCHER NO',
  'dashboard.colClientBill': 'CLIENT BILL',
  'dashboard.colStatus': 'STATUS',
  'dashboard.colDeliveryDate': 'DELIVERY DATE',
  'dashboard.colCustomer': 'CUSTOMER',
  'dashboard.colAddress': 'DELIVERY ADDRESS',
  'dashboard.loadingData': 'Loading dashboard data...',

  // Deliveries
  'deliveries.title': 'Deliveries',
  'deliveries.subtitle': 'Manage and track all your deliveries',
  'deliveries.searchPlaceholder': 'Search by voucher, bill no, customer, or address...',
  'deliveries.todaysOrders': "Today's Orders",
  'deliveries.todaysOrdersHint': 'Detailed view of all orders with comprehensive information',
  'deliveries.totalOrders': 'Total Orders:',
  'deliveries.loading': "Loading today's orders...",
  'deliveries.emptyTitle': 'No orders found',
  'deliveries.emptySubtitle': 'No orders for today or try adjusting your filters.',

  // New Order
  'newOrder.title': 'New Delivery Order',
  'newOrder.editTitle': 'Edit Delivery Order',
  'newOrder.subtitle': 'Create a new delivery order for your client',
  'newOrder.editSubtitle': 'Update order details and save changes',
  'newOrder.pickupInfo': 'Pickup Information',
  'newOrder.pickupAddress': 'Pickup Address',
  'newOrder.choosePickup': 'Choose Pickup Address',
  'newOrder.orderDetails': 'Order Details',
  'newOrder.type': 'Type',
  'newOrder.selectType': 'Select Type',
  'newOrder.customerInfo': 'Customer Information',
  'newOrder.customerName': 'Customer Name',
  'newOrder.searchCustomer': 'Search customer name...',
  'newOrder.mobileNumber': 'Mobile Number',
  'newOrder.mobileNumber2': 'Mobile Number 2',
  'newOrder.fullAddress': 'Full Address',
  'newOrder.additionalDetails': 'Additional Details',
  'newOrder.quantity': 'Quantity',
  'newOrder.remarks': 'Remarks',
  'newOrder.productPrice': 'Product Price',
  'newOrder.options': 'Options',
  'newOrder.exchange': 'Exchange?',
  'newOrder.fragile': 'Fragile?',
  'newOrder.deliverySchedule': 'Delivery Schedule',
  'newOrder.actions': 'Actions',
  'newOrder.saveOrder': 'Save Order',
  'newOrder.saveAndPrint': 'Save & Print',

  // Upload Orders
  'upload.title': 'Bulk Order Entry',
  'upload.subtitle': 'Upload Excel file to create multiple orders at once',
  'upload.batch': 'Batch #',
  'upload.template': 'Template',
  'upload.preparing': 'Preparing...',
  'upload.plainTitle': 'Plain Excel',
  'upload.plainDesc': 'Empty template, free-text fields',
  'upload.emiratesTitle': 'With Emirates',
  'upload.emiratesDesc': 'Emirate column as selectable dropdown',
  'upload.emiratesLocationsTitle': 'With Emirate & Locations',
  'upload.emiratesLocationsDesc': 'Emirate + Location dropdowns (cascading)',
  'upload.uploadAndPrint': 'Upload & Print',
  'upload.processing': 'Processing...',
  'upload.uploadOnly': 'Upload Only',
  'upload.uploadAndPrint1': 'Upload and Print 1',
  'upload.uploadAndPrint2': 'Upload and Print 2',
  'upload.selectPickup': 'Select Pickup Address',
  'upload.selectAddress': 'Select Address',
  'upload.chooseExcel': 'Choose Excel File',
  'upload.clickOrDrag': 'Click to upload or drag and drop',
  'upload.fileTypes': 'Excel files (.xlsx, .xls)',
  'upload.ordersCount': 'Orders ({count})',
  'upload.applyDate': 'Apply Date',
  'upload.noOrders': 'No orders loaded',
  'upload.uploadHint': 'Upload an Excel file to see orders here',

  // Tracking
  'tracking.title': 'Track Orders',
  'tracking.subtitle': 'Enter voucher numbers to track your orders',
  'tracking.voucherNumbers': 'Voucher Numbers',
  'tracking.placeholder': 'Enter Voucher Numbers Ex: 101.150.554.6658 etc',
  'tracking.orderOf': 'Order {current} of {total}',
  'tracking.orderInfo': 'Order Info',
  'tracking.pickupAddress': 'Pickup Address',
  'tracking.deliveryAddress': 'Delivery Address',
  'tracking.paymentInfo': 'Payment Info',
  'tracking.deliveryInfo': 'Delivery Info',
  'tracking.emptyTitle': 'Track Your Orders',

  // Track by customer / bill
  'trackCustomer.title': 'Track by Customer',
  'trackCustomer.subtitle': 'Search orders by customer name or mobile number',
  'trackCustomer.placeholder': 'Enter customer name or mobile number',
  'trackCustomer.results': 'Search Results ({count} orders found)',
  'trackBill.title': 'Track by Bill Number',
  'trackBill.subtitle': 'Search orders by client bill number',
  'trackBill.placeholder': 'Enter bill number',

  // Order details
  'orderDetails.title': 'Order Details',
  'orderDetails.notFound': 'Order Not Found',
  'orderDetails.notFoundBody': "The order you're looking for doesn't exist or you don't have permission to view it.",
  'orderDetails.backToDeliveries': 'Back to Deliveries',

  // My Customers
  'customers.title': 'My Customers',
  'customers.subtitle': 'Manage and view your customer information',
  'customers.searchPlaceholder': 'Search customers...',
  'customers.loading': 'Loading customers...',
  'customers.empty': 'No customers available',
  'customers.emptyFiltered': 'No customers found',

  // Batch printing
  'batch.title': 'Batch Printing',
  'batch.subtitle': 'Enter a batch number to generate and print PDF reports.',
  'batch.batchNumber': 'Batch Number',
  'batch.placeholder': 'Enter Batch No',
  'batch.printBatch': 'Print Batch',
  'batch.helpTitle': 'How to use Batch Printing',
  'batch.step1': 'Get the batch number from the order report / list',
  'batch.step2': 'Enter the batch number in the input field above',
  'batch.step3': 'Click "Print Batch" button or press Enter',
  'batch.step4': 'The PDF report will open in a new tab for printing or downloading',
  'batch.hint': 'Please enter a batch number to proceed with printing.',
  'batch.support': "Need help? Contact support if you're having trouble with batch printing.",

  // Settings / Profile
  'settings.title': 'Profile',
  'settings.subtitle': 'Manage your account preferences and settings',
  'settings.tabProfile': 'Profile',
  'settings.tabAddresses': 'Addresses',
  'settings.tabBank': 'Bank Details',
  'settings.tabPassword': 'Change Password',
  'settings.tabNotifications': 'Notifications',
  'settings.tabPreferences': 'Preferences',
  'settings.tabSignOut': 'Sign Out',
  'settings.profileInfo': 'Profile Information',
  'settings.editProfile': 'Edit Profile',
  'settings.addresses': 'Addresses',
  'settings.addAddress': 'Add New Address',
  'settings.bankDetails': 'Bank Details',
  'settings.changePassword': 'Change Password',
  'settings.notifications': 'Notification Preferences (Coming Soon)',
  'settings.preferences': 'Application Preferences (Coming Soon)',

  // Reports
  'orderReports.title': 'Order Reports',
  'orderReports.subtitle': 'Generate and view detailed order reports with advanced filtering',
  'orderReports.filters': 'Advanced Filters',
  'orderReports.filtersHint': 'Refine your search with multiple criteria',
  'customerReport.title': 'Customer Reports',
  'customerReport.subtitle': 'Generate and view detailed customer order reports with advanced filtering',
  'paymentReport.title': 'Payment Reports',
  'paymentReport.subtitle': 'Generate and view detailed payment reports with comprehensive filtering',
  'paymentReport.filters': 'Payment Filters',
  'paymentReport.records': 'Payment Records',
  'returnReport.title': 'Return Reports',
  'returnReport.subtitle': 'Generate and view detailed return reports with comprehensive filtering',
  'returnReport.filters': 'Return Filters',
  'returnReport.records': 'Return Records',
  'vatReport.title': 'VAT Reports',
  'vatReport.subtitle': 'Generate and view detailed VAT reports with comprehensive filtering',
  'vatReport.filters': 'VAT Filters',
  'vatReport.records': 'VAT Records',

  // Notifications
  'notifications.title': 'Notifications',
  'notifications.subtitle': 'Stay updated with your latest notifications',
  'notifications.empty': 'No Notifications',
  'notifications.emptyBody': "You don't have any notifications at the moment."
};

const ar = {
  'common.loading': 'جاري التحميل...',
  'common.retry': 'إعادة المحاولة',
  'common.refresh': 'تحديث',
  'common.search': 'بحث',
  'common.track': 'تتبع',
  'common.applyFilters': 'تطبيق الفلاتر',
  'common.reset': 'إعادة تعيين',
  'common.exportExcel': 'تصدير إكسل',
  'common.print': 'طباعة',
  'common.printing': 'جاري الطباعة...',
  'common.cancel': 'إلغاء',
  'common.close': 'إغلاق',
  'common.save': 'حفظ',
  'common.saveChanges': 'حفظ التغييرات',
  'common.saving': 'جاري الحفظ...',
  'common.edit': 'تعديل',
  'common.view': 'عرض',
  'common.status': 'الحالة',
  'common.history': 'السجل',
  'common.previous': 'السابق',
  'common.next': 'التالي',
  'common.fromDate': 'من تاريخ',
  'common.toDate': 'إلى تاريخ',
  'common.keyword': 'كلمة البحث',
  'common.allStatus': 'كل الحالات',
  'common.allEmirates': 'كل الإمارات',
  'common.notAvailable': 'غير متوفر',
  'common.actions': 'الإجراءات',
  'common.pickupDate': 'تاريخ الاستلام',
  'common.deliveryDate': 'تاريخ التوصيل',
  'common.voucherNo': 'رقم القسيمة',
  'common.clientBillNo': 'رقم فاتورة العميل',
  'common.customer': 'العميل',
  'common.address': 'العنوان',
  'common.location': 'الموقع',
  'common.emirate': 'الإمارة',
  'common.selectEmirate': 'اختر الإمارة',
  'common.noAddressesAvailable': 'لا توجد عناوين',
  'common.contactSupportAddresses': 'يرجى التواصل مع الدعم لإضافة عناوين',
  'common.selectAddressFirst': 'يرجى اختيار عنوان أولاً',
  'common.loadMore': 'تحميل المزيد',
  'common.loadingMore': 'جاري تحميل المزيد...',
  'common.noMoreToLoad': 'لا توجد سجلات إضافية',
  'common.language': 'اللغة',
  'common.english': 'English',
  'common.arabic': 'العربية',
  'common.collapse': 'طي القائمة',
  'common.expand': 'توسيع القائمة',

  'app.logout.title': 'تأكيد تسجيل الخروج',
  'app.logout.subtitle': 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
  'app.logout.warningTitle': 'سيتم تسجيل خروجك من حسابك',
  'app.logout.warningBody': 'سيتم فقدان جميع التغييرات غير المحفوظة وستحتاج لتسجيل الدخول مرة أخرى للوصول إلى حسابك.',
  'app.logout.confirm': 'نعم، تسجيل الخروج',

  'sidebar.brandTitle': 'بوابة التوصيل',
  'sidebar.brandSubtitle': 'لوحة تحكم العميل',
  'sidebar.userFallback': 'اسم المستخدم',
  'sidebar.dashboard': 'لوحة التحكم',
  'sidebar.newOrder': 'طلب جديد',
  'sidebar.uploadOrders': 'رفع الطلبات',
  'sidebar.deliveries': 'التوصيلات',
  'sidebar.tracking': 'التتبع',
  'sidebar.trackOrders': 'تتبع الطلبات',
  'sidebar.trackByCustomer': 'تتبع بالعميل',
  'sidebar.trackByBillNo': 'تتبع برقم الفاتورة',
  'sidebar.myCustomers': 'عملائي',
  'sidebar.batchPrinting': 'طباعة الدفعة',
  'sidebar.reports': 'التقارير',
  'sidebar.orderReports': 'تقارير الطلبات',
  'sidebar.customerReport': 'تقرير العملاء',
  'sidebar.paymentReport': 'تقرير المدفوعات',
  'sidebar.returnReport': 'تقرير المرتجعات',
  'sidebar.vatReport': 'تقرير الضريبة',
  'sidebar.profile': 'الملف الشخصي',
  'sidebar.logout': 'تسجيل الخروج',

  'dashboard.title': 'لوحة التحكم',
  'dashboard.subtitle': 'مرحباً بعودتك! إليك ما يحدث في توصيلاتك.',
  'dashboard.errorTitle': 'خطأ في تحميل لوحة التحكم',
  'dashboard.errorNetwork': 'خطأ في الشبكة - فشل تحميل بيانات لوحة التحكم',
  'dashboard.totalCustomers': 'إجمالي العملاء',
  'dashboard.totalOrders': 'إجمالي الطلبات',
  'dashboard.todaysOrders': 'طلبات اليوم',
  'dashboard.todayDelivered': 'تم توصيلها اليوم',
  'dashboard.totalClientMoney': 'إجمالي أموال العميل',
  'dashboard.totalClientReturns': 'إجمالي مرتجعات العميل',
  'dashboard.fromLastMonth': 'من الشهر الماضي',
  'dashboard.pickupDeliveryStatus': 'حالة الاستلام / التوصيل',
  'dashboard.noData': 'لا توجد بيانات',
  'dashboard.processing': 'قيد المعالجة',
  'dashboard.delivered': 'تم التوصيل',
  'dashboard.returned': 'مرتجع',
  'dashboard.cancelled': 'ملغى',
  'dashboard.deliveryStatistics': 'إحصائيات التوصيل',
  'dashboard.todaysStatus': 'حالة اليوم',
  'dashboard.todayProcessing': 'قيد المعالجة اليوم',
  'dashboard.todayReturned': 'مرتجع اليوم',
  'dashboard.todayCancelled': 'ملغى اليوم',
  'dashboard.recentDeliveries': 'التوصيلات الأخيرة',
  'dashboard.viewAll': 'عرض الكل',
  'dashboard.noRecent': 'لا توجد توصيلات حديثة',
  'dashboard.colVoucher': 'رقم القسيمة',
  'dashboard.colClientBill': 'فاتورة العميل',
  'dashboard.colStatus': 'الحالة',
  'dashboard.colDeliveryDate': 'تاريخ التوصيل',
  'dashboard.colCustomer': 'العميل',
  'dashboard.colAddress': 'عنوان التوصيل',
  'dashboard.loadingData': 'جاري تحميل بيانات لوحة التحكم...',

  'deliveries.title': 'التوصيلات',
  'deliveries.subtitle': 'إدارة وتتبع جميع توصيلاتك',
  'deliveries.searchPlaceholder': 'ابحث برقم القسيمة أو الفاتورة أو العميل أو العنوان...',
  'deliveries.todaysOrders': 'طلبات اليوم',
  'deliveries.todaysOrdersHint': 'عرض تفصيلي لجميع الطلبات مع معلومات شاملة',
  'deliveries.totalOrders': 'إجمالي الطلبات:',
  'deliveries.loading': 'جاري تحميل طلبات اليوم...',
  'deliveries.emptyTitle': 'لا توجد طلبات',
  'deliveries.emptySubtitle': 'لا توجد طلبات لليوم أو جرّب تعديل الفلاتر.',

  'newOrder.title': 'طلب توصيل جديد',
  'newOrder.editTitle': 'تعديل طلب التوصيل',
  'newOrder.subtitle': 'إنشاء طلب توصيل جديد لعميلك',
  'newOrder.editSubtitle': 'تحديث تفاصيل الطلب وحفظ التغييرات',
  'newOrder.pickupInfo': 'معلومات الاستلام',
  'newOrder.pickupAddress': 'عنوان الاستلام',
  'newOrder.choosePickup': 'اختر عنوان الاستلام',
  'newOrder.orderDetails': 'تفاصيل الطلب',
  'newOrder.type': 'النوع',
  'newOrder.selectType': 'اختر النوع',
  'newOrder.customerInfo': 'معلومات العميل',
  'newOrder.customerName': 'اسم العميل',
  'newOrder.searchCustomer': 'ابحث عن اسم العميل...',
  'newOrder.mobileNumber': 'رقم الجوال',
  'newOrder.mobileNumber2': 'رقم الجوال 2',
  'newOrder.fullAddress': 'العنوان الكامل',
  'newOrder.additionalDetails': 'تفاصيل إضافية',
  'newOrder.quantity': 'الكمية',
  'newOrder.remarks': 'ملاحظات',
  'newOrder.productPrice': 'سعر المنتج',
  'newOrder.options': 'الخيارات',
  'newOrder.exchange': 'تبديل؟',
  'newOrder.fragile': 'قابل للكسر؟',
  'newOrder.deliverySchedule': 'جدول التوصيل',
  'newOrder.actions': 'الإجراءات',
  'newOrder.saveOrder': 'حفظ الطلب',
  'newOrder.saveAndPrint': 'حفظ وطباعة',

  'upload.title': 'إدخال الطلبات بالجملة',
  'upload.subtitle': 'ارفع ملف إكسل لإنشاء عدة طلبات دفعة واحدة',
  'upload.batch': 'دفعة #',
  'upload.template': 'القالب',
  'upload.preparing': 'جاري التجهيز...',
  'upload.plainTitle': 'إكسل عادي',
  'upload.plainDesc': 'قالب فارغ بحقول نص حر',
  'upload.emiratesTitle': 'مع الإمارات',
  'upload.emiratesDesc': 'عمود الإمارة كقائمة اختيار',
  'upload.emiratesLocationsTitle': 'مع الإمارة والمواقع',
  'upload.emiratesLocationsDesc': 'قوائم الإمارة والموقع (مترابطة)',
  'upload.uploadAndPrint': 'رفع وطباعة',
  'upload.processing': 'جاري المعالجة...',
  'upload.uploadOnly': 'رفع فقط',
  'upload.uploadAndPrint1': 'رفع وطباعة 1',
  'upload.uploadAndPrint2': 'رفع وطباعة 2',
  'upload.selectPickup': 'اختر عنوان الاستلام',
  'upload.selectAddress': 'اختر العنوان',
  'upload.chooseExcel': 'اختر ملف إكسل',
  'upload.clickOrDrag': 'انقر للرفع أو اسحب وأفلت',
  'upload.fileTypes': 'ملفات إكسل (.xlsx, .xls)',
  'upload.ordersCount': 'الطلبات ({count})',
  'upload.applyDate': 'تطبيق التاريخ',
  'upload.noOrders': 'لا توجد طلبات محمّلة',
  'upload.uploadHint': 'ارفع ملف إكسل لعرض الطلبات هنا',

  'tracking.title': 'تتبع الطلبات',
  'tracking.subtitle': 'أدخل أرقام القسائم لتتبع طلباتك',
  'tracking.voucherNumbers': 'أرقام القسائم',
  'tracking.placeholder': 'أدخل أرقام القسائم مثال: 101.150.554.6658',
  'tracking.orderOf': 'طلب {current} من {total}',
  'tracking.orderInfo': 'معلومات الطلب',
  'tracking.pickupAddress': 'عنوان الاستلام',
  'tracking.deliveryAddress': 'عنوان التوصيل',
  'tracking.paymentInfo': 'معلومات الدفع',
  'tracking.deliveryInfo': 'معلومات التوصيل',
  'tracking.emptyTitle': 'تتبع طلباتك',

  'trackCustomer.title': 'تتبع بالعميل',
  'trackCustomer.subtitle': 'ابحث عن الطلبات باسم العميل أو رقم الجوال',
  'trackCustomer.placeholder': 'أدخل اسم العميل أو رقم الجوال',
  'trackCustomer.results': 'نتائج البحث ({count} طلب)',
  'trackBill.title': 'تتبع برقم الفاتورة',
  'trackBill.subtitle': 'ابحث عن الطلبات برقم فاتورة العميل',
  'trackBill.placeholder': 'أدخل رقم الفاتورة',

  'orderDetails.title': 'تفاصيل الطلب',
  'orderDetails.notFound': 'الطلب غير موجود',
  'orderDetails.notFoundBody': 'الطلب الذي تبحث عنه غير موجود أو ليس لديك صلاحية لعرضه.',
  'orderDetails.backToDeliveries': 'العودة إلى التوصيلات',

  'customers.title': 'عملائي',
  'customers.subtitle': 'إدارة وعرض معلومات عملائك',
  'customers.searchPlaceholder': 'ابحث عن العملاء...',
  'customers.loading': 'جاري تحميل العملاء...',
  'customers.empty': 'لا يوجد عملاء',
  'customers.emptyFiltered': 'لم يتم العثور على عملاء',

  'batch.title': 'طباعة الدفعة',
  'batch.subtitle': 'أدخل رقم الدفعة لإنشاء وطباعة تقارير PDF.',
  'batch.batchNumber': 'رقم الدفعة',
  'batch.placeholder': 'أدخل رقم الدفعة',
  'batch.printBatch': 'طباعة الدفعة',
  'batch.helpTitle': 'كيفية استخدام طباعة الدفعة',
  'batch.step1': 'احصل على رقم الدفعة من تقرير / قائمة الطلبات',
  'batch.step2': 'أدخل رقم الدفعة في الحقل أعلاه',
  'batch.step3': 'انقر على زر "طباعة الدفعة" أو اضغط Enter',
  'batch.step4': 'سيفتح تقرير PDF في تبويب جديد للطباعة أو التنزيل',
  'batch.hint': 'يرجى إدخال رقم الدفعة للمتابعة مع الطباعة.',
  'batch.support': 'تحتاج مساعدة؟ تواصل مع الدعم إذا واجهت مشكلة في طباعة الدفعة.',

  'settings.title': 'الملف الشخصي',
  'settings.subtitle': 'إدارة تفضيلات حسابك والإعدادات',
  'settings.tabProfile': 'الملف',
  'settings.tabAddresses': 'العناوين',
  'settings.tabBank': 'تفاصيل البنك',
  'settings.tabPassword': 'تغيير كلمة المرور',
  'settings.tabNotifications': 'الإشعارات',
  'settings.tabPreferences': 'التفضيلات',
  'settings.tabSignOut': 'تسجيل الخروج',
  'settings.profileInfo': 'معلومات الملف الشخصي',
  'settings.editProfile': 'تعديل الملف',
  'settings.addresses': 'العناوين',
  'settings.addAddress': 'إضافة عنوان جديد',
  'settings.bankDetails': 'تفاصيل البنك',
  'settings.changePassword': 'تغيير كلمة المرور',
  'settings.notifications': 'تفضيلات الإشعارات (قريباً)',
  'settings.preferences': 'تفضيلات التطبيق (قريباً)',

  'orderReports.title': 'تقارير الطلبات',
  'orderReports.subtitle': 'إنشاء وعرض تقارير الطلبات التفصيلية مع فلترة متقدمة',
  'orderReports.filters': 'فلاتر متقدمة',
  'orderReports.filtersHint': 'حسّن البحث بمعايير متعددة',
  'customerReport.title': 'تقارير العملاء',
  'customerReport.subtitle': 'إنشاء وعرض تقارير طلبات العملاء التفصيلية مع فلترة متقدمة',
  'paymentReport.title': 'تقارير المدفوعات',
  'paymentReport.subtitle': 'إنشاء وعرض تقارير المدفوعات التفصيلية مع فلترة شاملة',
  'paymentReport.filters': 'فلاتر المدفوعات',
  'paymentReport.records': 'سجلات المدفوعات',
  'returnReport.title': 'تقارير المرتجعات',
  'returnReport.subtitle': 'إنشاء وعرض تقارير المرتجعات التفصيلية مع فلترة شاملة',
  'returnReport.filters': 'فلاتر المرتجعات',
  'returnReport.records': 'سجلات المرتجعات',
  'vatReport.title': 'تقارير الضريبة',
  'vatReport.subtitle': 'إنشاء وعرض تقارير الضريبة التفصيلية مع فلترة شاملة',
  'vatReport.filters': 'فلاتر الضريبة',
  'vatReport.records': 'سجلات الضريبة',

  'notifications.title': 'الإشعارات',
  'notifications.subtitle': 'ابقَ على اطلاع بأحدث إشعاراتك',
  'notifications.empty': 'لا توجد إشعارات',
  'notifications.emptyBody': 'ليس لديك أي إشعارات في الوقت الحالي.'
};

export const translations = { en, ar };
